import { useEffect, useState } from 'react';
import { Wifi, WifiOff } from 'lucide-react';

export function NetworkStatusBadge() {
  const [online, setOnline] = useState(typeof navigator !== 'undefined' ? navigator.onLine : true);

  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);

  return (
    <div
      className={`flex items-center gap-2 px-2 py-1.5 rounded text-[11px] font-medium ${
        online ? 'bg-emerald-500/10 text-emerald-400' : 'bg-amber-500/10 text-amber-400'
      }`}
    >
      {online ? <Wifi size={12} /> : <WifiOff size={12} />}
      <span>{online ? 'Conectado' : 'Sin conexión'}</span>
    </div>
  );
}
